// sitesApi.js
import React from "react";
import axios from "axios";
import APIURL from "../../../Main/apiurl";

const create_site = async (site) => {
    try {
        let data = {
            name: site?.name,
            address: site?.address,
            gps_coordinates: site?.gps_coordinates,
            manager: site?.manager,
            type: site?.type || "Site",
            contact_number: site?.contact_number,
            status: site?.status
        };

        const token = localStorage.getItem("user");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.post(
            `${APIURL}/create-site`,
            data,
            config
        );

        if (response?.data?.status_code == 401) {
            localStorage.clear();
            window.location.href = "/";
            return response?.data;
        } else {
            return response?.data;
        }
    } catch (error) {
        return error;
    }
};

const update_site = async (site) => {
    try {
        let data = {
            id: site?.id,
            name: site?.name,
            address: site?.address,
            gps_coordinates: site?.gps_coordinates,
            manager: site?.manager,
            type: site?.type || "Site",
            contact_number: site?.contact_number,
            status: site?.status
        };

        const token = localStorage.getItem("user");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.post(
            `${APIURL}/update-site`,
            data,
            config
        );

        if (response?.data?.status_code == 401) {
            localStorage.clear();
            window.location.href = "/";
            return response?.data;
        } else {
            return response?.data;
        }
    } catch (error) {
        return error;
    }
};

const delete_site = async (site) => {
    try {
        let data = {
            id: site?.id,
        };

        const token = localStorage.getItem("user");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.post(
            `${APIURL}/delete-site`,
            data,
            config
        );

        if (response?.data?.status_code == 401) {
            localStorage.clear();
            window.location.href = "/";
            return response?.data;
        } else {
            return response?.data;
        }
    } catch (error) {
        return error;
    }
};

const get_site = async (site) => {
    try {
        let data = {
            id: site?.id,
        };

        const token = localStorage.getItem("user");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.post(`${APIURL}/get-site`, data, config);

        if (response?.data?.status_code == 401) {
            localStorage.clear();
            window.location.href = "/";
            return response?.data;
        } else {
            return response?.data;
        }
    } catch (error) {
        return error;
    }
};

const get_all_sites = async (site) => {
    try {
        const data = {
            search: site?.search,
            type: site?.type,
            status: site?.status
        };

        const token = localStorage.getItem("user");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.post(
            `${APIURL}/get-all-sites`,
            data,
            config
        );

        if (response?.data?.status_code == 401) {
            localStorage.clear();
            window.location.href = "/";
            return response?.data;
        } else {
            return response?.data;
        }
    } catch (error) {
        return error;
    }
};

export {
    create_site,
    update_site,
    delete_site,
    get_site,
    get_all_sites,
};